export class LinksItemModel {
    id: number;
    webAddress: string;
    ranking?: number;
}
